/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Deadline_InvalidInputs */

const en_task_deadline_invalid = /** @type {(inputs: Task_Deadline_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a valid deadline date.`)
};

const pt_br2_task_deadline_invalid = /** @type {(inputs: Task_Deadline_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma data de prazo válida.`)
};

/**
* | output |
* | --- |
* | "Select a valid deadline date." |
*
* @param {Task_Deadline_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_deadline_invalid = /** @type {((inputs?: Task_Deadline_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Deadline_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_deadline_invalid(inputs)
	return pt_br2_task_deadline_invalid(inputs)
});